var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#334368",
    fillRule: "evenodd",
    d: "M9.3 3.8a2.1 2.1 0 0 0-2.1 2.1v28.2c0 1.16.94 2.1 2.1 2.1h21.4c1.16 0 2.1-.94 2.1-2.1V13.4a2.1 2.1 0 0 0-.62-1.49l-7.5-7.5a2.1 2.1 0 0 0-1.49-.61zm2.1 4.2h10.5v6.3c0 1.16.94 2.1 2.1 2.1h4.6V32H11.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#334368",
    d: "M14.2 20.4h11.6v3.4H14.2zM14.2 26.2h8.4v3.4h-8.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNote);
export default __webpack_public_path__ + "static/media/icon-note.d1ad7e9ed6e6d4064da8085d2b40f48b.svg";
export { ForwardRef as ReactComponent };